export class Parent {
  objDiff(oldObj, newObj) {
    for (const key in newObj) {
      const element = newObj[key]
      if (typeof element === "object" && Object.prototype.hasOwnProperty.call(oldObj, key)) {
        this.objDiff(oldObj[key], element)
      } else {
        oldObj[key] = element
      }
    }
  }
  hasVal(val, key) {
    if (typeof val === "undefined" || val === null) return undefined
    //键名是数字,说明是在获取数组数据
    if (!this.iN(key) && this.iA(val)) {
      return val[key]
    } else {
      //获取对象数据
      return val.hasOwnProperty(key) ? true : false
    }
  }
  getAndSetPrimaryVal(origin, k, primaryVal) {
    if (this.hasVal(origin, k)) {
      return origin[k]
    } else return primaryVal
  }
  iA(arr) {
    return Array.isArray(arr)
  }
  iN(num) {
    return isNaN(num)
  }
  assign(origin, target) {
    for (let k in target) {
      if (target[k] === "deleteProperty") {
        delete origin[k]
      } else {
        origin[k] = target[k]
      }
    }
    return origin
  }
}
